'use client'

import { Code, Database, Dice, GamePad, Programming, Star, Web } from '@/lib/icons'
import JourneyStep from './JourneyStep'


const Journey = () => {
    const journeySteps = [
        {
            date: "October 2020",
            title: "Computer Science Foundation",
            description: "Began my CS degree at UET Lahore, picking up C++, HTML, CSS and JavaScript while building console games.",
            icon: <Code className="text-2xl" />,
            technologies: ['C++', 'HTML', 'CSS', 'JavaScript'],
            videoId: "ZYa-52u5twg?si=XM2RndA9AKoRl1--"
        },
        {
            date: "March 2021",
            title: "JavaScript Gaming Revolution",
            description: "Shipped 9 JavaScript games and began exploring Three.js for 3D on the web.",
            icon: <GamePad className="text-2xl" />,
            technologies: ['JavaScript', 'Canvas', 'Three.js'],
            videoId: "gYnJTultFI0?si=kCPXE1NzOXKhck-F"
        },
        {
            date: "August 2021",
            title: "Unity Mastery & First Client",
            description: "Picked up the Unity Game Engine, moved into freelancing on Fiverr and landed my first client.",
            icon: <Dice className="text-2xl" />,
            technologies: ['Unity', 'C#', 'Fiverr'],
            videoId: "4vmNCYxIzCw?si=yNYSFSWV7v06FdrZ"
        },
        {
            date: "January 2022",
            title: "Tech Stack Expansion",
            description: "Client work started arriving for Three.js, React.js, Phaser.js, and Pixi.js projects.",
            icon: <Programming className="text-2xl" />,
            technologies: ['Three.js', 'React.js', 'Phaser.js', 'Pixi.js']
        },
        {
            date: "October 2022",
            title: "Database & Backend Mastery",
            description: "Got to grips with MSSQL, MongoDB, and Firebase, building scalable data solutions on top of them.",
            icon: <Database className="text-2xl" />,
            technologies: ['MSSQL', 'MongoDB', 'Firebase'],
            videoId: "Bx7LcDfu6GU"
        },
        {
            date: "February 2023",
            title: "Modern Web & Multiplayer Gaming",
            description: "Dug into Next.js alongside Socket.io, Geckos.io and Colyseus.io, then jumped into multiplayer game development.",
            icon: <Web className="text-2xl" />,
            technologies: ['Next.js', 'Socket.io', 'Geckos.io', 'Colyseus.io', 'Node.js'],
            videoId: "ihJj5UX3fT0"
        },
        {
            date: "2023 - Present",
            title: "Professional Excellence",
            description: "Freelancing steadily on Upwork (10+ jobs) and Fiverr (200+ orders) with a consistent track record.",
            icon: <Star className="text-2xl" />,
            technologies: ['Upwork', 'Fiverr', 'Freelancing'],
            linkTo: { url: '/works', text: 'Explore My Works' }
        }
    ]

    return (
        <section className="w-full mt-16 sm:mt-20 md:mt-32">
            <div className="w-full px-2 sm:px-0 max-w-5xl mx-auto">
                <div className="text-center mb-12">
                    <h2 className="font-bold text-2xl md:text-4xl mb-4">
                        My Professional Journey
                    </h2>
                    <p className="text-sm sm:text-base text-light/60 max-w-2xl mx-auto">
                        From Computer Science student to professional full-stack and game developer,
                        here&apos;s how it all came together over the years.
                    </p>
                </div>

                <div className="relative">
                    <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-1 bg-gradient-to-b from-transparent via-accent/30 to-transparent h-full rounded-full">
                        <div className="absolute inset-0 bg-gradient-to-b from-accent/10 via-accent/20 to-accent/10 rounded-full" />
                    </div>
                    <div className="md:hidden absolute left-4 w-1 bg-gradient-to-b from-transparent via-accent/30 to-transparent h-full rounded-full">
                        <div className="absolute inset-0 bg-gradient-to-b from-accent/10 via-accent/20 to-accent/10 rounded-full" />
                    </div>

                    <div className="space-y-0 pt-8 pb-8">
                        {journeySteps.map((step, index) => (
                            <JourneyStep
                                key={index}
                                date={step.date}
                                title={step.title}
                                description={step.description}
                                icon={step.icon}
                                isLeft={index % 2 === 1}
                                videoId={step.videoId}
                                technologies={step.technologies}
                                linkTo={step.linkTo}
                                index={index}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Journey
